import { parsePhoneNumber, CountryCode } from 'libphonenumber-js';

export const formatPhoneNumber = (phoneNumber: string, defaultCountry: CountryCode = 'RU'): string => {
  try {
    // If the phone number doesn't start with '+', assume it's a local number and add the country code
    const numberWithCountryCode = phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;
    const parsedNumber = parsePhoneNumber(numberWithCountryCode, defaultCountry);
    if (parsedNumber) {
      return parsedNumber.formatInternational();
    }
  } catch (error) {
    console.error('Error formatting phone number:', error);
  }
  return phoneNumber; // Return original if parsing fails
};